<template>
  <div>
    <page-header
      title="Transload & Return to Base"
      breadcrumb="Bookings & Shipments  >  Incident & Request >  Process Relief Vehicle > Transload & Return to Base"
      :back="back"
    />
    
    <div class="card table-header mt-4">
      <div class="flex justify-between">
        <div class="group-options-select">
          <div class="flex" v-if="currentTab != 'incident'">
            <div class="mr-2 shadow-table p-2 filter">
              <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
            </div>
            <div class="table__search-input-wrapper">
              <span class="pr-2 opacity-50"><search-icon /> </span>
              <input
                type="text"
                class="table__search-input"
                placeholder="Search..."
                v-model="query"
              />
              <img src="@/assets/images/icons/search.svg" alt="search icon" />
            </div>
          </div>
        </div>

        <div class="flex gap-4">
          <span class="shadow-table rounded-md p-2">Bulk Actions</span>
          <base-button text="Apply"/>
          <button class="shadow-table rounded-md p-2">
            <img src="@/assets/images/icons/print-icon.svg" alt="print icon" />
          </button>
          <button class="shadow-table rounded-md p-2">
            <img
              src="@/assets/images/icons/refresh-icon.svg"
              alt="refresh icon"
            />
          </button>
        </div>
      </div>

      <div class="responsive-table" id="table-wrapper">
        <table class="custom-table responsive-table border-collapse">
          <thead>
            <tr class="shadow-table rounded-lg">
              <th>
                <base-checkbox />
              </th>
              <th>Shipping Ref</th>
              <th>Description</th>
              <th>Weight (kg)</th>
              <th>Sender</th>
              <th>Address</th>
              <th>Receiver</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody v-if="!loading">
            <tr class="shadow-table rounded-lg">
              <td>
                <base-checkbox />
              </td>
              <td>MX000323</td>
              <td>Bale od clothes</td>
              <td>540.00</td>
              <td>Nodce rw</td>
              <td>No. 4 Aku Str., Epe,  Lagos.</td>
              <td>Binta Dasukki</td>
              <td>No. 1 Doe Str., GRA, Enugu</td>
            </tr>
          </tbody>
        </table>

      </div>
      <pagination-control />
    </div>
  </div>
</template> 

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/NewPagination";


export default {
  components: {
    PageHeader,
    PaginationControl
  },
  props: ['back'],
  data() {
    return {
      query: "",
      count: {},
    };
  },
  watch: {
    currentTab(val) {
      this.$store.dispatch("setCurrentUsersAndGroupTab", val);
    },
  },
  mounted() {
    const currentTab = this.$store.getters.currentUserAndGroupsTab;
    if (currentTab) {
      this.currentTab = currentTab;
    }
  },
  methods: {
    showDeleteModal(payload) {
      this.itemToDelete = payload[0];
      this.selectedId = payload[1];
      this.isDeleteModal = true;
    },
    async deleteUser() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteUser(this.selectedId);
        this.onDeleteUser(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    async deleteGroup() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteGroup(this.selectedId);
        this.onDeleteGroup(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    onDeleteUser(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      this.$refs.usersDataTable.getAllUsers();
      this.generateToast("User successfully deleted!", "success");
    },
    onDeleteGroup(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      // this.fetchGroups = true;
      this.$refs.groupsDataTable.getAllGroups();
      this.generateToast("Group successfully deleted!", "success");
    },
    deleteItem() {
      if (this.itemToDelete == "User") {
        this.deleteUser();
      } else if (this.itemToDelete == "Group") {
        this.deleteGroup();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>